import React from "react";
import {
	PageTemplateProps,
	PageTemplate,
} from "src/components/common/PageTemplate";
import { PurchaseRequestsDataGrid } from "src/components/views/erp/purchase/PurchaseRequestsDataGrid";

export const PurchaseRequestsPage = React.memo(
	(props: PageTemplateProps) => {
		return (
			<PageTemplate {...props}>
				<PurchaseRequestsDataGrid />
			</PageTemplate>
		);
	},
);
